<!-- 头部导航栏 -->
<template>
  <div>
    <header>
      <div class="header-contariner">
        <!-- 左侧图标 点击跳转到首页 -->
        <router-link to="/" class="logo-icon">
          <img src="../assets/images/logo.png">
        </router-link>
        <!-- 右浮动列表 -->
        <div class="header-list">
          <ul>
            <li>
              <router-link to="/" exact>{{ mainPage }}</router-link>
            </li>
            <li>
              <router-link to="/about">{{ aboutUs }}</router-link>
            </li>
            <!-- <li>
              <router-link to="/news">最新活动</router-link>
            </li> -->
            <li>
              <router-link to="/corp">{{ enterpriseUser }}</router-link>
            </li>
            <li>
              <div class="language-switch">
                <select id="language-select" v-model="currentLang" @change="langChange">
                  <option value="ja">日本語</option>
                  <option value="zh">中文</option>
                </select>
                <span class="arrow"></span>
              </div>
            </li>
            <li>
              <!-- 电话移出 -->
              <img src="../assets/images/common/tel.gif">
              <div class="header-list-block">
                <div>
                  <p>{{ contactTip }}:092-791-7271</p>
                  <span>{{ contactContent }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </header>
    <nav></nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentLang: 'ja'
    }
  },
  computed: {
    mainPage() {
      return this.$store.getters.currentLang === 'zh' ? '首页' : 'トップページ'
    },
    aboutUs() {
      return this.$store.getters.currentLang === 'zh' ? '关于我们' : '私たちについて'
    },
    enterpriseUser() {
      return this.$store.getters.currentLang === 'zh' ? '企业用户' : '企業ユーザー'
    },
    contactTip() {
      return this.$store.getters.currentLang === 'zh' ? '欢迎合作详谈' : '協力の詳細な話し合いを歓迎します'
    },
    contactContent() {
      return this.$store.getters.currentLang === 'zh' ? '我们将为您提供支持客户成长战略所需的IT解决方案' : 'お客様の成長戦略をサポートするITソリューションをお届けします'
    }
  },
  mounted() {
    console.log(this.$store.getters.currentLang)
    let currentLang = this.$store.getters.currentLang
    if (currentLang) {
      this.currentLang = currentLang
    } else {
      this.currentLang = 'zh'
      this.langChange()
    }
  },
  methods: {
    langChange() {
      this.$store.dispatch('ChangeLang', this.currentLang)
      location.reload()
    }
  }
}
</script>

<style scoped lang="scss">
// 把下面的块往下挤
nav {
  width: 100%;
  height: 60px;
  background: transparent;
}

.language-switch {
  position: relative;
  display: inline-block;
}

.language-switch select {
  padding: 5px 24px 5px 5px;
  border: none;
  background-color: #f2f2f2;
  color: #333;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.language-switch .arrow {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 5px 0 5px;
  border-color: #333 transparent transparent transparent;
}

// 所有的router-link都有这个类，添加父级来限定他
ul .router-link-active {
  color: $luck_header_list_color !important;
  border-bottom: 2px solid $luck_header_list_color;
}

// 顶部导航栏  fix定位
header {
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 60px;
  background: $write;
  box-shadow: 0px 2px 5px $luck_shadow;
  font-family: $luck_font;

  // 功能样式  被outer-link-active替代
  .active {
    color: $luck_header_list_color !important;
    border-bottom: 2px solid $luck_header_list_color;
  }

  // 导航  居中容器
  .header-contariner {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: inherit;

    a {
      line-height: 60px;
    }

    a>img {
      width: 167px;
    }

    // 右浮动列表
    .header-list {
      float: right;

      li {
        min-width: 80px;
        margin-left: 10px;
        line-height: 60px;
        float: left;
        font-family: Times New Roman;
        font-size: $luck_font_header;
        font-weight: bolder;
        text-align: center;

        &:first-child {
          // width: 50px;
        }

        &:last-child {
          position: relative;

          .header-list-block {
            // 电话图标移出图案
            opacity: 0;
            position: absolute;
            top: 36px;
            right: 0;
            width: 380px;
            height: 0px;
            line-height: 22px;
            background: url(../assets/images/common/hoverbg.png) no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            transition: opacity 0.17s linear;

            div {
              margin: 32px auto;
              width: 300px;
              height: 70px;
              // display: flex;
              // align-items: center;
              // flex-direction: column;
              // justify-content: center;
              text-align: center;

              p {
                color: $luck_header_list_color;
                font-size: 24px;
                font-weight: bold;
              }

              span {
                font-size: 16px;
                color: #7f8cd6;
              }
            }
          }

          &:hover {
            .header-list-block {
              opacity: 1;
              height: 130px;
            }
          }
        }
      }

      li>a {
        padding-bottom: 0.6rem;
        transition: all 0.13s linear;
        cursor: pointer;
      }

      li>img {
        cursor: pointer;
      }
    }
  }
}
</style>